import { render, staticRenderFns } from "./LegosHQ.vue?vue&type=template&id=f939b71a&scoped=true&"
import script from "./LegosHQ.vue?vue&type=script&lang=ts&"
export * from "./LegosHQ.vue?vue&type=script&lang=ts&"
import style0 from "./LegosHQ.vue?vue&type=style&index=0&id=f939b71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f939b71a",
  null
  
)

export default component.exports